<div class="mobile-module-tab flex min-h-0 flex-1 flex-col gap-4">
  @if (config(); as moduleTabConfig) {
    @if (moduleTabConfig.Items?.length) {
      @let activeWidgetIndex = moduleTabConfig.ActualWidgetIndex;
      @let activeItem = moduleTabConfig.Items![activeWidgetIndex];
      <div class="flex shrink-0 flex-col gap-2">
        @if (showCloseButton()) {
          <div class="flex justify-end">
            <button
              type="button"
              class="mobile-module-tab__close inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#ece4f3] bg-white text-[#3d2652] shadow-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
              [attr.aria-label]="'common.close' | translate"
              (click)="onCloseClick()"
            >
              <span class="material-icons text-xl leading-none" aria-hidden="true">close</span>
            </button>
          </div>
        }
        <div
          class="mobile-module-tab__progress pointer-events-none flex min-h-[48px] shrink-0 select-none items-stretch gap-1 rounded-xl border border-[#e4dbe8] bg-[#f3f1f6] px-1 py-1"
          role="status"
          aria-live="polite"
        >
          <span
            class="mobile-module-tab__chev mobile-module-tab__chev--decor flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-[#bcb0cc]"
            aria-hidden="true"
          >
            <span class="material-icons text-[26px]" aria-hidden="true">chevron_left</span>
          </span>
          <div class="flex min-w-0 flex-1 items-center justify-center px-2 text-center">
            <span class="mobile-module-tab__step-label inline-flex max-w-full min-w-0 items-center justify-center gap-2 text-sm font-semibold leading-snug">
              @if (activeItem) {
                <span class="min-w-0 truncate">{{ activeItem.Label | translate }}</span>
                <span class="mobile-module-tab__step-badge shrink-0">
                  <span class="mobile-module-tab__step-index tabular-nums font-semibold leading-none">{{ activeWidgetIndex + 1 }}/{{ moduleTabConfig.Items!.length }}</span>
                </span>
              }
            </span>
          </div>
          <span
            class="mobile-module-tab__chev mobile-module-tab__chev--decor flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-[#bcb0cc]"
            aria-hidden="true"
          >
            <span class="material-icons text-[26px]" aria-hidden="true">chevron_right</span>
          </span>
        </div>
      </div>
    }
  } @else if (steps()?.length) {
    @let activeStepIndex = activeIndex();
    @let activeStep = steps()![activeStepIndex];
    <div class="flex shrink-0 flex-col gap-2">
      @if (showCloseButton()) {
        <div class="flex justify-end">
          <button
            type="button"
            class="mobile-module-tab__close inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#ece4f3] bg-white text-[#3d2652] shadow-sm transition-colors hover:bg-[#faf7fc] active:bg-[#f5f0fa]"
            [attr.aria-label]="'common.close' | translate"
            (click)="onCloseClick()"
          >
            <span class="material-icons text-xl leading-none" aria-hidden="true">close</span>
          </button>
        </div>
      }
      <div
        class="mobile-module-tab__progress pointer-events-none flex min-h-[48px] shrink-0 select-none items-stretch gap-1 rounded-xl border border-[#e4dbe8] bg-[#f3f1f6] px-1 py-1"
        role="status"
        aria-live="polite"
      >
        <span
          class="mobile-module-tab__chev mobile-module-tab__chev--decor flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-[#bcb0cc]"
          aria-hidden="true"
        >
          <span class="material-icons text-[26px]" aria-hidden="true">chevron_left</span>
        </span>
        <div class="flex min-w-0 flex-1 items-center justify-center px-2 text-center">
          <span class="mobile-module-tab__step-label inline-flex max-w-full min-w-0 items-center justify-center gap-2 text-sm font-semibold leading-snug">
            @if (activeStep) {
              <span class="min-w-0 truncate">{{ activeStep.labelKey | translate }}</span>
              <span class="mobile-module-tab__step-badge shrink-0">
                <span class="mobile-module-tab__step-index tabular-nums font-semibold leading-none">{{ activeStepIndex + 1 }}/{{ steps()!.length }}</span>
              </span>
            }
          </span>
        </div>
        <span
          class="mobile-module-tab__chev mobile-module-tab__chev--decor flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-[#bcb0cc]"
          aria-hidden="true"
        >
          <span class="material-icons text-[26px]" aria-hidden="true">chevron_right</span>
        </span>
      </div>
    </div>
  }

  <div class="min-h-0 flex-1 overflow-y-auto">
    <ng-content />
  </div>

  @if (showWizardNavigation()) {
    <footer class="shrink-0 border-t border-[#ece4f3] pt-3">
      <mobile-wizard-navigation
        [config]="config()"
        [wizardInstanceId]="wizardInstanceId()"
        [isNavigating]="isNavigating()"
        [showSaveAsDraft]="showSaveAsDraft()"
        [isSaving]="isSaving()"
        [allowSubmit]="allowSubmit()"
        [allowSaveAsDraft]="allowSaveAsDraft()"
        (previous)="wizardPrevious.emit()"
        (next)="wizardNext.emit()"
        (saveAsDraft)="wizardSaveAsDraft.emit()"
        (submit)="wizardSubmit.emit()"
        (wizardStepChanged)="wizardStepChanged.emit($event)"
      />
    </footer>
  }
</div>
